export default "__VITE_ASSET__Cu3oeEe0__"